export enum TypeModalEnum {
  information = 'information',
  attention = 'attention',
  important = 'important'
}
